import axios from 'axios';

import {
  TGET_POLL_RES, TRESET_PDATA, TGETTING_RAND_POLL,
  TEDIT_POLL, TNOT_GOT_RAND_POLL, TRESET_RESULTS,
  TGETTING_POLL, TGOT_POLL , TNOT_GOT_POLL, TGOT_RAND_POLL,
  TSEARCHING_POLLS, TSEARCHED_POLLS, TNOT_SEARCHED_POLLS,
  TCREATING_POLL, TCREATED_POLL, TNOT_CREATED_POLL,
  TGETTING_TWTS, TGOT_TWTS, TNOT_GOT_TWTS,
  TDELETING_POLL, TDELETED_POLL, TNOT_DELETED_POLL,
  TVOTING, TVOTED, TNOT_VOTED,
} from './types';
import {
  PCREATE_POLL, PGET_POLL, PGET_POLL_RES, PVOTE_POLL,
  PRANDOM_POLL, PGET_TWTS, PEDIT_POLL, PDELETE_POLL, PSEARCH_POLLS,
} from './paths';
import {UROOT_API, API_HEADERS, GENERIC_HEADER} from './api_const';
import {getCurUserJWT} from './firebase_actions';

// default twts, TODO get these from the database
const test_ids = ['1064284782035705857', '1064194412987772929', '1063622851184533510',
'1064133709257994241', '1063159732616101888', '1062492975865966593','1062426711663484930',
'1062218556526546944', '1062167790138937344','1062020244888264705','1061952024353366016']

//// POLL API ACTIONS ////
export function resetPollData() {
  return ({type: TRESET_PDATA});
};

export function resetPollResults() {
  return ({type: TRESET_RESULTS});
};

export const createPoll = (pollInfo, hist) => {
  const {question, descrip, img_url, thumb_url, answers, token} = pollInfo;
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TCREATING_POLL});
    axios.post(UROOT_API+PCREATE_POLL, {
      question, descrip, img_url, thumb_url, answers
    }, {headers})
      .then(resp => {
        dispatch({type: TCREATED_POLL});
        hist.push(`/poll/${resp.data.hash}`)
      })
      .catch(err => {
        dispatch({type: TNOT_CREATED_POLL, errMsg: err});
        window.confirm('Cannot create poll right now... please try again or contact support@pollpals.com');
      });
  };
};

export const getPoll = (pollid, redirCb) => {
  const headers = Object.assign({}, GENERIC_HEADER);

  return (dispatch) => {
    dispatch({type: TGETTING_POLL});
    axios.get(`${UROOT_API}${PGET_POLL}${pollid}`, {headers})
      .then( resp => {
        dispatch({
          type: TGOT_POLL,
          data: resp.data
        })
      })
      .catch(err => {
        if (err.message === 'Request failed with status code 404') {
          redirCb();
        }
        dispatch({type: TNOT_GOT_POLL, errMsg: err.message});
      });
  }
};

export const searchPolls = (query) => {
  const headers = Object.assign({}, GENERIC_HEADER);

  return (dispatch) => {
    dispatch({type: TSEARCHING_POLLS});
    axios.get(`${UROOT_API}${PSEARCH_POLLS}${query}`, {headers})
      .then( resp => {
        dispatch({
          type: TSEARCHED_POLLS,
          data: resp.data
        })
      })
      .catch(err => dispatch({type: TNOT_SEARCHED_POLLS, errMsg: err}));
  }
};

export async function deletePoll(pollid) {
  const token = await getCurUserJWT();
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TDELETING_POLL});
    axios.put(`${UROOT_API}${PDELETE_POLL}`, {pid: pollid}, {headers})
      .then( resp => {
        dispatch({
          type: TDELETED_POLL,
          data: resp.data
        })
      })
      .catch(err => dispatch({type: TNOT_DELETED_POLL, errMsg: err}));
  }
}

export async function editPollInfo(newData) {
  // console.log('new poll data to add', newData);
  const token = await getCurUserJWT();
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  const req = axios.post(UROOT_API+PEDIT_POLL, newData, {headers});

  return ({
    type: TEDIT_POLL,
    payload: req,
  });
}

// export const getPollResults = (pollid, callback) => {
//   const headers = Object.assign({}, GENERIC_HEADER);
//
//   return (dispatch) => {
//     dispatch({type: TGETTING_RESULTS});
//     axios.get(`${UROOT_API}${PGET_POLL_RES}${pollid}`, {headers})
//       .then(resp => {
//         dispatch({type: TGOT_RESULTS, results: resp.data});
//         callback();
//       })
//       .catch(err => dispatch({type: TNOT_GOT_RESULTS, errMsg: err}) );
//   };
// };

export function getPollResults(pollid, token=null) {
  // const headers = API_HEADERS;
  // const headers = {"Content-Type": "application/json"};
  const headers = Object.assign({}, GENERIC_HEADER);

  // // TODO check that API accepts req with no token
  // if (token !== null) {
  //   headers['X-Auth-User'] = token;
  // }
  // console.log('head:', headers)
  const req = axios.get(`${UROOT_API}${PGET_POLL_RES}${pollid}`, {headers});

  return ({
    type: TGET_POLL_RES,
    payload: req,
  });
}

// NOTE checking the loading somwhere else? works as is, might need to tweak later
export const votePoll = (voteInfo, callback) => {
  const {poll_id, answer_id, token, vote_id} = voteInfo;
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TVOTING});
    axios.post(UROOT_API+PVOTE_POLL, {poll_id, answer_id, vote_id}, {headers})
      .then(resp => {
        dispatch({type: TVOTED, vote_results: resp.data});
        callback();
      })
      .catch(err => dispatch({type: TNOT_VOTED, errMsg: err}));
  };
};

export const getRandPoll = () => {
  const headers = Object.assign({}, GENERIC_HEADER);

  return (dispatch) => {
    dispatch({type: TGETTING_RAND_POLL});
    axios.get(UROOT_API+PRANDOM_POLL, {headers})
      .then(resp => {
        dispatch({type: TGOT_RAND_POLL, random: resp.data});
      })
      .catch(err => dispatch({type: TNOT_GOT_RAND_POLL, errMsg: err}));
  };
};

export const getTweets = (search_term, token=null) => {
  const headers = Object.assign({}, GENERIC_HEADER);
  // // TODO add API accepting req with a token??
  // // QUESTION only get new tweets if token?
  // if (token !== null) {
  //   headers['X-Auth-User'] = token;
  // }
  // console.log('head:', headers)

  return (dispatch) => {
    dispatch({type: TGETTING_TWTS});
    axios.get(`${UROOT_API}${PGET_TWTS}${search_term}`, {headers})
      .then(resp => {
        let twtids = resp.data.twtids;
        if (twtids.length <= 3 || resp.data.isEmpty) {
          console.log('using default twts. ');
          twtids = test_ids;
        }
        dispatch({type: TGOT_TWTS, twts: twtids});
      })
      .catch(err => {
        console.log('twt err, using default twts. ');
        dispatch({
          type: TNOT_GOT_TWTS,
          twts: test_ids,
          errMsg: err,
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/poll_api_actions.js